module.exports = __webpack_public_path__ + "img/inner-cub.1fbecb41.jpg";